(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Open external links in new tabs
  document.addEventListener("DOMContentLoaded", function(event) {
    let links = document.querySelectorAll(".footer-block--menu a");

    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.isBlending = this.classList.contains('header--blending');
      if (this.isBlending) {
        this.header.classList.add('header--blending');
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Open external links in new tabs
  window.addEventListener("load", function(event) {
    const links = document.querySelectorAll("header a.list-menu__item");

    for (const link of links) {
      if (link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }
    }

    // Handle the account dropdown
    let hideTimeout = null;

    const showDropdown = function() {
      clearTimeout(hideTimeout);
      document.querySelector('.header__account-dropdown').classList.add('show');
    };

    const hideDropdown = function() {
      hideTimeout = setTimeout(() => {
        accountLink.parentElement.classList.remove('show');
      }, 500);
    };

    const accountLink = document.querySelector('.header__icon--account.dropdown-toggle');
    const accountDropdown = document.querySelector('.header__account-dropdown .dropdown-menu');
    if (accountLink && accountDropdown) {
      accountLink.addEventListener('click', function(ev) {
        ev.preventDefault();
      });

      'mouseenter touchstart'.split(' ').forEach(function(evName) {
        accountLink.addEventListener(evName, function(ev) {
          showDropdown();
        });
      });

      'mouseleave touchleave'.split(' ').forEach(function(evName) {
        accountLink.addEventListener(evName, function(ev) {
          hideDropdown();
        });
      });


      'mouseenter touchstart'.split(' ').forEach(function(evName) {
        accountDropdown.addEventListener(evName, function(ev) {
          showDropdown();
        });
      });
      'mouseleave touchleave'.split(' ').forEach(function(evName) {
        accountDropdown.addEventListener(evName, function(ev) {
          hideDropdown();
        });
      });
    }

    /**
     * Handle the Mobile menu, inner submenu containers, when they overflow - add some classes so we can style them
     * with CSS (ie. add arrow).
     */
    const computeOverflowClassesForElement = function(elem) {
      if (elem.scrollHeight > elem.clientHeight) {
        elem.parentElement.classList.add('submenu-overflows');

        // elem.scrollTop can be float, and never fully scroll until the "integer" part - so we ceil it
        if (Math.ceil(elem.scrollTop) + elem.offsetHeight >= elem.scrollHeight) {
          elem.parentElement.classList.add('submenu-fully-scrolled');
        } else {
          elem.parentElement.classList.remove('submenu-fully-scrolled');
        }

        if (elem.scrollTop === 0) {
          elem.parentElement.classList.add('submenu-top-scrolled');
        } else {
          elem.parentElement.classList.remove('submenu-top-scrolled');
        }
      } else {
        elem.parentElement.classList.remove('submenu-overflows', 'submenu-fully-scrolled', 'submenu-top-scrolled');
      }
    };

    const debounce = function(func, timeout = 300) {
      let timer;

      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    };

    const debouncedComputeOverflowClassesForElement = debounce(computeOverflowClassesForElement, 50);

    const computeOverflowClasses = function (entries, observer) {
      entries.forEach((entry) => {
        computeOverflowClassesForElement(entry.target);
      });
    };
    let observer = new IntersectionObserver(computeOverflowClasses, { root: null });

    const mobileInnerSubmenuContainers = document.querySelectorAll('#menu-drawer .menu-drawer__inner-submenu');
    mobileInnerSubmenuContainers.forEach((elem) => {
      observer.observe(elem);

      elem.addEventListener("scroll", function(event) {
        debouncedComputeOverflowClassesForElement(event.target);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
